module.exports = __webpack_public_path__ + "static/media/Cision.ed3ca77d.svg";